import _some from "lodash/some";
import _get from "lodash/get";
export var getHasPendingRequestsForActionName = function getHasPendingRequestsForActionName(identity, actionName) {
  var requestReducer = _get(identity, "requests.".concat(actionName));

  return _get(requestReducer, 'hasPendingRequests', false);
};
export var getHasPendingRequestsForActionNames = function getHasPendingRequestsForActionNames(identity, actionNames) {
  return _some(actionNames, function (name) {
    return getHasPendingRequestsForActionName(identity, name);
  });
};